import { CameraOutlined, CloseOutlined } from '@vindr/icons';
import { Button } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useCaptureManagerState } from '../context';

const OpenCameraIcon = () => {
  const { t } = useTranslation('Vindoc');
  const { appearance, showCamera, setShowCamera } = useCaptureManagerState();

  const handleShowCamera = useCallback(() => {
    setShowCamera((prev) => !prev);
  }, []);

  if (appearance !== 'hide-camera' && showCamera) return null;

  return (
    <Button
      className="flex items-center text-3xl"
      onClick={() => handleShowCamera()}
      title={t('Open Camera')}
      icon={showCamera ? <CloseOutlined className="text-xl leading-none" /> : <CameraOutlined />}
    >
      <span className="text-base">{t(showCamera ? 'Close Camera' : 'Open Camera')}</span>
    </Button>
  );
};

export default OpenCameraIcon;
